import { EVENTS } from '../events';

export class SearchPlugin {
	constructor(chat) {
		this.chat = chat;
	}

	init() {
		jQuery(document).on('keyup', '#wschat-search-input', _.debounce(this.search.bind(this), 500));
		const self = this;
		jQuery(document).on('click', '.wschat-search-result-item', function (e) {
			self.fetch_messages(jQuery(this).data('message-id'));
		});

		jQuery(document).on('click', '.wschat-search-post-item-send', function (e) {
			e.preventDefault();
			self.chat.send_message({
				// Type is text by default now, it needs to changed based on the selection content
				wschat_ajax_nonce: wschat_ajax_obj.nonce,
				type: 'text',
				'content[text]': jQuery(this).attr('href'),
				'content[url]': jQuery(this).attr('href'),
			});
		});
	}

	search() {
		const data = {
			search: jQuery(document).find('#wschat-search-input').val(),
			type: jQuery(document).find('#wschat-search-mode').val(),
			conversation_id: this.chat.conversation.id,
			action: 'wschat_admin_get_messages'
		};

		if (data.search.length < 2) {
			return;
		}

		if (data.type === 'posts') {
			data.action = 'wschat_admin_search_posts';
		}

		const progress = jQuery(document).find('.wschat-search-progress-bar');
		progress.removeClass('d-none');

		jQuery.post(this.chat.options.api.endpoint, data, res => {
			this.render_results(res.data, data.type);
			progress.addClass('d-none');
		}).fail(f => {
			progress.removeClass('d-none');
		});
	}

	render_results(data, type) {
		const results = jQuery(document).find('.wschat-search-results');
		console.log(data)

		if (data[type].length === 0) {
			results.html('<p>No results found</p>');
			return;
		}

		results.html('');

		data[type].forEach(message => {
			results.append(searchResultItem(message, type));
		});
	}

	fetch_messages(message_id) {
		const item = this.find_message_item_by_id(message_id);

		if (item.length) {
			return this.scroll_to(item);
		}

		const data = {
			after: 0,
			before: parseInt(message_id, 10) + 1,
			limit: 5,
			no_pong: true,
		};

		this.chat.connector.get_messages(data);
		data.before = 0;
		data.after = message_id;
		this.chat.connector.get_messages(data);
		this.chat.scroll_to = message_id;
	}

	find_message_item_by_id(id) {
		return jQuery('.message-item[data-message-id=' + id + ']');
	}

	scroll_to(item) {
		setTimeout(() => {
			jQuery('.message-item.bg-warning').removeClass('bg-warning')
			item.addClass('bg-warning');
			if (item.length) {
				const top = item.offset().top - 500;
				chat_panel.scrollTop(chat_panel.scrollTop() + top);
			}
		}, 500)
	}
}

const searchResultItem = (data, type) => {
	return templates[type](data);
}

const templates = {
	messages : message => {
		return `
			<p class="mb-1 wschat-search-result-item p-1" data-message-id="${message.id}">
				<small>${message.created_at}</small><br>
				<span class="message-text">${message.body.text}</span>
			</p>
		`;
	},
	posts : post_type => {
		if (post_type.posts.length === 0) {
			return '';
		}

		const content = `
			<div>
				<div class="d-flex justify-content-between">
					<h6>${post_type.title}</h6>
					<span class="material-icons">arrow_down</span>
				</div>
				${post_type.posts.map(post => renderPostTemplate(post)).join()}
			</div>
		`;

		return content;
	}
}

const renderPostTemplate = post => {
	return `
		<div class="border d-flex justify-content-between align-items-center shadow-sm p-1 wschat-search-post-item">
			<img src="${post.thumbnail || 'https://via.placeholder.com/35'}" class="img-fluid img-thumbnail ratio ratio-1x1" />
				<h6 class="flex-grow-1 wschat-search-post-item-title">${post.title}</h6>
				<a class="btn btn-primary p-1 flex-shrink-1 wschat-search-post-item-send" href="${post.url}" target="_blank">
					<span class="material-icons">send</span>
				</a>
		</div>
	`;
}
